import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  content: string;
  age: number;
}
export function TestimonialCard({
  name,
  role,
  location,
  content,
  age
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-stone-200" data-id="element-280">
      <div className="flex gap-1 mb-4" data-id="element-281">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-282" />)}
      </div>
      <p className="text-stone-700 italic mb-6 text-lg" data-id="element-283">"{content}"</p>
      <div className="flex items-center gap-3" data-id="element-284">
        <div className="w-10 h-10 bg-stone-200 rounded-full flex items-center justify-center text-stone-600 font-bold" data-id="element-285">
          {name.charAt(0)}
        </div>
        <div data-id="element-286">
          <p className="font-bold text-stone-900" data-id="element-287">
            {name}, {age} años
          </p>
          <p className="text-sm text-stone-500" data-id="element-288">
            {role} • {location}
          </p>
        </div>
      </div>
    </div>;
}